import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer active:scale-[0.98]',
  {
    variants: {
      variant: {
        default: 'bg-accent text-accent-foreground hover:bg-accent-hover shadow-[0_10px_30px_rgba(244,196,95,0.22)]',
        secondary:
          'bg-surface-soft text-foreground hover:bg-surface-hover border border-border-subtle hover:border-border-strong',
        ghost: 'hover:bg-surface-soft text-foreground',
        outline:
          'border border-border-subtle bg-transparent text-foreground hover:bg-surface-soft hover:border-border-strong',
        link: 'text-accent underline-offset-4 hover:underline',
        destructive: 'bg-danger text-foreground hover:bg-danger/90',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-10 px-3.5 text-sm',
        xs: 'h-8 px-2.5 text-xs',
        lg: 'h-12 px-6 text-base',
        icon: 'h-10 w-10',
        'icon-sm': 'h-8 w-8',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
